import { useTheme } from '@mui/material';
import { RouterLink } from './RouterLink';

// ----------------------------------------------------------------------

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  disabledLink?: boolean;
  showText?: boolean;
  showPointerCursor?: boolean;
  onClick?: () => void;
}

export default function Logo({
  disabledLink = false,
  showText = true,
  showPointerCursor,
  style,
  onClick,
}: Props) {
  const logoCss = `
            .cls-1 {
              fill: #f89521;
      }

            .cls-2 {
              fill: #fff;
      }

            .cls-3 {
              fill: #231f20;
      }
`;

  const logo = (
    <div
      style={{ width: showText ? 113 : 40, height: 40, ...style }}
      onClick={onClick}
    >
      <svg
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={`0 0 ${showText ? '984' : '350'} 350`}
      >
        <defs>
          <style>{logoCss}</style>
          <clipPath id="clip0">
            <rect
              width="112.328"
              height="42.0276"
              fill="white"
              transform="translate(0.200684 0.491211)"
            />
          </clipPath>
        </defs>
        <g>
          <path
            className="cls-2"
            d="m288.4,310.96c38.68-32.26,63.33-80.79,63.33-135.09C351.72,78.74,272.99,0,175.86,0S0,78.74,0,175.86c0,66.24,36.65,123.86,90.75,153.86l197.65-18.76Z"
          />
          <path d="m221.79,124.17c-44.22-13.85-168.14-4.18-168.14-4.18,0,20.51,16.58,37.14,37.07,37.24v12.35h0v160.12c25.24,14,54.24,22.03,85.15,22.03,42.79,0,81.99-15.31,112.48-40.72l-59.55-116.27,17.88-34.9c9.3-18.16-5.42-29.57-24.89-35.67Z" />
          <g>
            <path
              className="cls-2"
              d="m175.2,157.21c-10.27,0-18.59,8.32-18.59,18.59s8.32,18.59,18.59,18.59,18.59-8.33,18.59-18.59-8.33-18.59-18.59-18.59Z"
            />
            <circle className="cls-2" cx="175.86" cy="175.86" r="55.72" />
            <path
              className="cls-1"
              d="m282.95,164.54l-37.46-2.39-18.69,36.47c-.09.17.11-.15,0,0-7.36,16.04-22.47,28.31-40.24,31.8l95.13-5.5c5.01-.5,10.1,1.48,13,5.6,1.78,2.53,2.75,5.66,2.53,8.97-.09,1.46-.41,2.85-.91,4.15l.09.12,15.01-25.58c13.45-22.91-1.97-51.95-28.48-53.64Z"
            />
            <path d="m175.2,157.21c-10.27,0-18.59,8.32-18.59,18.59s8.32,18.59,18.59,18.59,18.59-8.33,18.59-18.59-8.33-18.59-18.59-18.59Z" />
          </g>
          <path
            className="cls-3"
            d="m90.72,231.59v98.11c18.4,10.21,38.85,17.07,60.55,20.11l-60.55-118.22Z"
          />
        </g>
        <g>
          <path
            className="cls-2"
            d="m445.43,178.21v-.45c0-34.21,26.44-62.92,62.7-62.92,18.94,0,31.93,6.15,42.18,15.04,1.82,1.6,4.34,5.02,4.34,9.57,0,7.07-5.7,12.54-12.77,12.54-3.42,0-6.39-1.37-8.22-2.74-7.07-5.92-14.82-10.25-25.76-10.25-20.07,0-34.88,17.32-34.88,38.31v.45c0,21.44,14.82,38.53,36.03,38.53,10.94,0,19.37-4.33,26.89-10.72,1.6-1.36,4.34-2.95,7.54-2.95,6.6,0,11.85,5.47,11.85,12.07,0,3.65-1.37,6.62-3.87,8.67-10.72,10.27-23.71,17.09-43.78,17.09-35.8,0-62.25-28.04-62.25-62.25Z"
          />
          <path
            className="cls-2"
            d="m590.28,92.96c0-7.54,5.94-13.69,13.69-13.69s13.92,6.15,13.92,13.69v42.85c7.75-11.17,18.92-20.97,37.61-20.97,27.14,0,42.88,18.24,42.88,46.05v64.3c0,7.75-5.94,13.69-13.69,13.69s-13.9-5.94-13.9-13.69v-55.85c0-18.71-9.35-29.43-25.78-29.43s-27.12,11.19-27.12,29.88v55.4c0,7.75-6.17,13.69-13.92,13.69s-13.69-5.94-13.69-13.69V92.96Z"
          />
          <path
            className="cls-2"
            d="m739.72,92.96c0-7.54,5.94-13.69,13.69-13.69s13.92,6.15,13.92,13.69v79.78l51.75-50.83c3.65-3.65,7.07-5.94,11.85-5.94,7.3,0,12.09,5.94,12.09,12.54,0,4.57-2.28,7.99-6.15,11.64l-31.93,29.41,36.48,47.65c2.52,3.42,3.65,5.92,3.65,9.12,0,7.52-5.92,12.54-12.99,12.54-5.47,0-8.67-1.82-12.09-6.17l-34.41-45.83-18.24,17.34v20.97c0,7.75-6.17,13.69-13.92,13.69s-13.69-5.94-13.69-13.69V92.96Z"
          />
          <path
            className="cls-2"
            d="m878.35,92.96c0-7.54,5.94-13.69,13.69-13.69s13.92,6.15,13.92,13.69v79.78l51.75-50.83c3.65-3.65,7.07-5.94,11.85-5.94,7.3,0,12.09,5.94,12.09,12.54,0,4.57-2.28,7.99-6.15,11.64l-31.93,29.41,36.48,47.65c2.52,3.42,3.65,5.92,3.65,9.12,0,7.52-5.92,12.54-12.99,12.54-5.47,0-8.67-1.82-12.09-6.17l-34.41-45.83-18.24,17.34v20.97c0,7.75-6.17,13.69-13.92,13.69s-13.69-5.94-13.69-13.69V92.96Z"
          />
        </g>
      </svg>
    </div>
  );

  if (disabledLink) {
    return (
      <div style={{ cursor: showPointerCursor ? 'pointer' : '' }}>{logo}</div>
    );
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
